import { Dispatch } from 'redux';
import { getTestResult } from 'Components/Quiz/api';
export const types = {
    REQUEST_RESULTS: 'REQUEST_RESULTS',
    RECEIVE_RESULTS: 'RECEIVE_RESULTS',
    FAILED_RESULTS: 'FAILED_RESULTS',
};
export const status = {
    INIT: 'INIT',
    FETCHING: 'FETCHING',
    SUCCESS: 'SUCCESS',
    ERROR: 'ERROR',
};
export const requestTestResults = () => ({
    type: types.REQUEST_RESULTS,
    status: status.FETCHING,
});
export const receiveTestResults = (compilations: any[]) => ({
    type: types.RECEIVE_RESULTS,
    payload: compilations,
    status: status.SUCCESS,
});
export const failedTestResults = () => ({
    type: types.FAILED_RESULTS,
    status: status.ERROR,
});
export const loadTestResults = (answers: any) => {
    return async (dispatch: Dispatch) => {
        dispatch(requestTestResults());
        try {
            const response = await getTestResult('/social/quiz/', answers);
            dispatch(receiveTestResults(response.compilations));
        }
        catch (error) {
            dispatch(failedTestResults());
        }
    };
};
